<template>
  <div>
    <BillingBalanceContainer
      v-if="!isRegStepper && canSeeBilling"
      class="cabinet__withdrawal pt-8"
      @update:withdraw="openWithdraw"
    ></BillingBalanceContainer>

    <Rating v-if="!isRegStepper && canSeeRating" :class="{ 'mt-8': canSeeBilling }" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Rating from "@/components/bids/Rating.vue";

export default {
  components: {
    Rating: () => import("@/components/bids/Rating.vue"),
    BillingBalanceContainer: () => import("@/components/common/BillingBalanceContainer.vue"),
  },

  computed: {
    ...mapGetters("profile", [
      "isRegStepper",
      "canSeeBilling",
      "canSeeRating",
    ]),
  },

  methods: {
    openWithdraw(value) {
      this.$store.commit("billing/showWithdrawalSidePanel", value);
    }
  }
}
</script>
